export default __webpack_public_path__ + "static/media/play_preview.173c6192.svg";